import React from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { isValidated } from '@packages/helpers/core/validations/is-password-valid';
import { withDebouncedHandlers } from '../../../helpers/hocs/with-debounced-handlers';
import { setAccountData, setAccountError, updatePassword } from '../../../store/reducers/account/actions';
import { InputField as Input } from '../../../components/inputs/input';
import { AccountPage } from '../../../templates/account';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { Validators, withoutUser } from '../components';

const AccountDetailsComponent = ({ password, newPassword, setData, validators, isValid, error, handleSubmit }) => {
  const {
    ACCOUNT: {
      MAIN: {
        pages: {
          changeDetails: {
            title,
            identifier,
            subheading,
            inPageMessage,
            message,
            heading,
            body,
            legalFooter,
            pageHeader,
            fields: { currentPassword: currentPasswordLabel, newPassword: newPasswordLabel },
            buttons: { confirm, forgotPassword }
          }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      legalFooter={legalFooter}
      onSubmit={handleSubmit}
      pageHeader={pageHeader}
    >
      <Input
        label={currentPasswordLabel}
        type='password'
        onChange={setData('password')}
        value={password}
        autoComplete='new-password'
      />
      <Input
        label={newPasswordLabel}
        type='password'
        onChange={setData('newPassword')}
        value={newPassword}
        error={error}
      />
      <Validators items={validators} />
      <ButtonWithIcon buttonType='submit' disabled={!isValid}>
        {confirm}
      </ButtonWithIcon>
      <ButtonWithIcon type='minor' to='/account/reset-password'>
        {forgotPassword}
      </ButtonWithIcon>
    </AccountPage>
  );
};

const mapDispatchToProps = ({ account }) => {
  const { validators, isValid } = isValidated(account.newPassword);

  return {
    password: account.password,
    newPassword: account.newPassword,
    validators,
    isValid: isValid && account.password !== account.newPassword,
    error: account.updatingPasswordError
  };
};

export const AccountDetails = compose(
  withoutUser(),
  connect(mapDispatchToProps, { setAccountData, updatePassword, setAccountError }),
  withHandlers({
    setData:
      ({ setAccountData }) =>
      name =>
      value =>
        setAccountData(name, value)
  }),
  withDebouncedHandlers({
    handleSubmit:
      ({ updatePassword, history }) =>
      () => {
        updatePassword(() => history.push('/account/details/complete'));
      }
  }),
  lifecycle({
    componentDidMount() {
      const { setAccountData } = this.props;

      setAccountData('password', '');
      setAccountData('newPassword', '');
      setAccountData('updatingPasswordError', '');
    },
    componentDidUpdate(prevProps) {
      const { password, newPassword, setAccountError } = this.props;

      if (password.length > 0 && password === newPassword && prevProps.isValid) {
        setAccountError('updatingPasswordError', `New password shouldn't be same`);
      }

      if ((prevProps.password !== password || prevProps.newPassword !== newPassword) && password !== newPassword) {
        setAccountError('updatingPasswordError', null);
      }
    }
  })
)(AccountDetailsComponent);
